import { useEffect } from 'react';
import { useRouter } from './router-provider';
import { RouteItem } from './types';

export const Route = ({ path, component }: RouteItem) => {
  const { registerRoute, currentRoute } = useRouter();

  useEffect(() => {
    registerRoute({ path, component });
  }, []);

  return currentRoute === path ? component : null as any;
};

export default Route;
